import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getApi, patchApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CardsBorder from "../../../components/Cards/CardsBorder";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as EditIcon } from "../../../assets/svgs/edit-icon.svg";
import dayjs from "dayjs";
import { Badge } from "../../../components/Elements/TextStyles/Badge";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { useNavigate } from "react-router-dom";
import CustomerAddNewSection from "./Roles/DIalogBoxes/CustomerAddNewSection";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
import CustomSwitch from "../../../components/Elements/CustomSwitch/CustomSwitch";
import CustomerSubSection from "./CustomerSubSection";
import CustomerUpdateSection from "./Roles/DIalogBoxes/CustomerUpdateSection";

const CustomerQuestionBank = ({ clientId }) => {
  const [tableData, setTableData] = useState([]);
  const [sectionId, setSectionId] = useState("");
  const [openUpdate, setOpenUpdate] = useState(false);
  const [sectionCreated, setSectionCreated] = useState(false);
  const [openAddNew, setOpenAddnew] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sectionName, setSectionName] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [sortOrder, setSortOrder] = useState("-createdAt");
  const [sectionUpdated, setSectionUpdated] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [popupData, setPopupData] = useState(null);
  const [subSectionOpen, setSubSectionOpen] = useState(false);
  const [loadingSwitchId, setLoadingSwitchId] = useState(null);
  const navigate = useNavigate();

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Section Name", key: "sectionName" },
      { label: "Created On", key: "createdOn" },
     { label:<div className="px-10">Status</div>, key: "status" },
      { label: "Action", key: "action" },
    ],
    []
  );
  const fetchQuestions = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOMER_QUESTION_BANK(
          currentPage,
          pageSize,
          sortOrder
          // searchTerm
        ),
        headers: { client: clientId },
      });
      if (response.success) {
        setPageSize(response.limit);
        setTotalRecords(response.total);
        setTableData(
          response.data.map((item, index) => ({
            serial: index + 1,
            sectionName: <div className="text-center">{item.name}</div>,
            createdOn: <div className="text-center">{dayjs(item.createdAt).format("DD MMM YYYY")}</div>,
            isActive:<div className="text-center">{item.isActive}</div>, // Add this to retain toggle state
            status: (
              <div className="flex justify-center">
                <Badge text={item.status} />
              </div>
            ),
            action: (
              <div className="flex gap-4 items-center justify-center">
                <GreenEye
                  onClick={() => {
                    setSubSectionOpen(true);
                    setSectionId(item._id);
                  }}
                />
                <EditIcon
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => {
                    setOpenUpdate(true);
                    setSectionId(item._id);
                    setSectionName(item.section);
                  }}
                />
                <CustomSwitch
                  checked={item.status === "Active" ? true : false}
                  onChange={() => handleStatusChange(item._id, item.isActive)}
                />
              </div>
            ),
          }))
        );
      }
    } catch (error) {
      console.error("Error is fetching Questions Table", error);
    }
  };

  const handleStatusChange = async (sectionId, currentStatus) => {
    try {
      setLoadingSwitchId(sectionId);
      const updatedStatus = currentStatus ? "Inactive" : "Active";

      const response = await patchApi({
        apiUrl: API_URLS.CUSTOMER_SECTION_STATUS_CHANGE(sectionId),
        data: { status: updatedStatus },
        headers: { client: clientId },
      });

      if (response.success) {
        setPopupData({
          type: "success",
          title: "Status Updated",
          message: `Section status changed to ${updatedStatus}.`,
        });
        fetchQuestions();
      } else {
        setPopupData({
          type: "warning",
          title: "Update Failed",
          message: response.message,
        });
      }
    } catch (error) {
      setPopupData({
        type: "error",
        title: "Error",
        message: "There was a problem updating the status.",
      });
      console.error("Error in updating status", error);
    } finally {
      setLoadingSwitchId(null);
      setTimeout(() => setPopupData(null), 2000);
    }
  };

  const handleOpenAddNew = () => {
    setOpenAddnew(true);
  };

  const handleSort = useCallback(() => {
    setSortOrder((prevOrder) =>
      prevOrder === "createdAt" ? "-createdAt" : "createdAt"
    );
  }, []);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  useEffect(() => {
    if (clientId) {
      fetchQuestions();
    }
  }, [clientId, currentPage, pageSize, sortOrder, searchTerm]);
  return (
    <div style={{paddingLeft:"40px",paddingRight:"40px",paddingTop:"20px"  }}>
      {!subSectionOpen && (
        <CardsBorder>
          <div className="flex justify-between gap-8 my-4 font-medium">
            <div className="flex">
              <p className="text-[#06513D] pt-2 px-10 text-xl">
                Customer Question Bank
              </p>
              <SearchBar width="300px" onSearch={setSearchTerm} />
            </div>
            <div className="flex gap-2 px-10">
              <CustomButton
                buttonType="primary"
                variant="ok"
                buttonText="View All Questions"
                className="text-sm h-[50px]"
                onClick={() => navigate("/question-bank/view-all")}
              />
              <CustomButton
                buttonType="primary"
                variant="ok"
                buttonText="+ ADD NEW"
                className="text-sm h-[50px]"
                onClick={handleOpenAddNew}
              />
            </div>
          </div>
          <Tables
            data={tableData}
            headers={headers}
            pageSize={pageSize}
            total={totalRecords}
            current={currentPage}
            onChange={handlePageChange}
            onSort={handleSort}
          />
        </CardsBorder>
      )}

      {openAddNew && (
        <CustomerAddNewSection
          onOpen={openAddNew}
          onClose={() => {
            setOpenAddnew(false);
            fetchQuestions();
          }}
          clientId={clientId}
          setSectionCreated={setSectionCreated}
          popupData={popupData}
          setPopupData={setPopupData}
        />
      )}

      {openUpdate && (
        <CustomerUpdateSection
          onOpen={openUpdate}
          onClose={() => {
            setOpenUpdate(false);
            fetchQuestions();
          }}
          clientId={clientId}
          setSectionUpdated={setSectionUpdated}
          sectionId={sectionId}
          sectionName={sectionName}
          popupData={popupData}
          setPopupData={setPopupData}
        />
      )}

      {subSectionOpen && (
        <CardsBorder>
          <CustomerSubSection
            sectionId={sectionId}
            clientId={clientId}
            setSubSectionOpen={setSubSectionOpen}
          />
        </CardsBorder>
      )}

      {popupData && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}
    </div>
  );
};

export default CustomerQuestionBank;
